import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function CustomCursor() {
  const [hovering, setHovering] = useState(false);
  const [visible, setVisible] = useState(false);
  const cx = useMotionValue(-100);
  const cy = useMotionValue(-100);
  const sx = useSpring(cx, { stiffness: 400, damping: 30, mass: 0.4 });
  const sy = useSpring(cy, { stiffness: 400, damping: 30, mass: 0.4 });

  useEffect(() => {
    const onMove = (e) => {
      cx.set(e.clientX);
      cy.set(e.clientY);
      setVisible(true);
    };
    const onOver = (e) => {
      const t = e.target;
      if (t && (t.closest("a") || t.closest("button") || t.closest("[data-cursor='hover']"))) {
        setHovering(true);
      } else {
        setHovering(false);
      }
    };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseover", onOver);
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseover", onOver);
    };
  }, [cx, cy]);

  // Hide on touch devices
  if (typeof window !== "undefined" && window.matchMedia("(pointer: coarse)").matches) return null;

  return (
    <motion.div
      className="pointer-events-none fixed top-0 left-0 z-[200] rounded-full"
      style={{
        x: sx,
        y: sy,
        translateX: "-50%",
        translateY: "-50%",
        width: hovering ? 42 : 14,
        height: hovering ? 42 : 14,
        backgroundColor: hovering ? "#E3FF00" : "#F4F4F0",
        mixBlendMode: "difference",
        opacity: visible ? 1 : 0,
        transition: "width 0.18s ease, height 0.18s ease, background-color 0.18s ease",
      }}
    />
  );
}
